import { Upload } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export interface DragOverlayProps {
  isDraggingOver: boolean;
  currentPath: { name: string }[];
  hasFiles: boolean;
  isViewer?: boolean; // 🔥 是否为 viewer 角色（只读模式）
}

export function DragOverlay({
  isDraggingOver,
  currentPath,
  hasFiles,
  isViewer = false,
}: DragOverlayProps) {
  const { t } = useTranslation();

  // 🔥 viewer 角色不显示拖拽覆盖层
  if (!isDraggingOver || !hasFiles || isViewer) {
    return null;
  }

  return (
    <div className="absolute inset-0 z-10 bg-blue-500/10 backdrop-blur-[2px] border-2 border-dashed border-blue-500 rounded-lg flex items-center justify-center pointer-events-none">
      <div className="bg-white/95 px-12 py-8 rounded-xl shadow-2xl border-2 border-blue-500 min-w-[400px]">
        <p className="text-2xl font-semibold text-blue-600 flex items-center justify-center gap-3">
          <Upload size={28} />
          {t('project.dropFilesHereToUploadTo')}{' '}
          {currentPath.length > 0
            ? `"${currentPath[currentPath.length - 1].name}"`
            : t('project.rootFolder')}
        </p>
      </div>
    </div>
  );
}

export default DragOverlay;
